/**
 * The platform sniffs the cast story needs. In-page casting (the
 * Presentation API) exists on desktop Chromium only: an iPhone can only
 * AirPlay-mirror its screen, a Mac on Safari mirrors through Control Center,
 * and Chrome on Android only presents registered receiver apps. Every dead
 * cast path names its mirror instead.
 */
export function isAppleMobile(): boolean {
  if (typeof navigator === 'undefined') return false;
  // iPadOS masquerades as macOS; a Mac never carries touch points.
  return (
    /iPhone|iPad|iPod/.test(navigator.userAgent) ||
    (navigator.maxTouchPoints > 1 && /Macintosh/.test(navigator.userAgent))
  );
}

/**
 * Safari on a Mac. Its way to an Apple TV is macOS Screen Mirroring, not
 * Chrome's tab cast — which cannot reach an Apple TV at all. Every other Mac
 * browser names itself in the user agent next to "Safari".
 */
export function isMacSafari(): boolean {
  if (typeof navigator === 'undefined' || isAppleMobile()) return false;
  const ua = navigator.userAgent;
  return /Macintosh/.test(ua) && /Safari\//.test(ua) && !/Chrome|Chromium|Edg\/|Firefox|OPR\//.test(ua);
}

/** Which Apple mirror the owner can reach for, or null off Apple's browsers. */
export type ApplePlatform = 'ios' | 'mac' | null;

export function applePlatform(): ApplePlatform {
  if (isAppleMobile()) return 'ios';
  if (isMacSafari()) return 'mac';
  return null;
}

export function isAndroid(): boolean {
  return typeof navigator !== 'undefined' && /Android/.test(navigator.userAgent);
}
